import React, { FC } from 'react';
import Image from 'next/image';
import AppUpsellCta from './AppUpsellCta';
import FFHModal from '@components/modal';
import { BodyRegular, H2 } from '@components/atoms/typography';

type AppUpsellModalProps = {
  storeUrl: string;
  ctaLabel: string;
  onCtaClick: () => void;
  onClose: () => void;
};

const AppUpsellModal: FC<AppUpsellModalProps> = ({
  storeUrl,
  ctaLabel,
  onCtaClick,
  onClose
}) => (
  <FFHModal
    open
    handleClose={onClose}
    title="The new FFH app is here"
    childrenClassName="w-[90vw] max-w-sm"
  >
    <div
      data-cy="app-upsell-modal"
      className="flex flex-col items-center text-center px-6 pt-10 pb-8"
    >
      {/* Placeholder shot until design supplies the final new-app asset */}
      <Image
        src="/images/new-app.png"
        alt="The new Fantasy Football Hub app"
        width={180}
        height={340}
        // Capped against the viewport so the image yields on short screens
        // (SE-class phones, landscape) and the CTA stays above the fold.
        className="mb-6 h-auto max-h-[40vh] w-auto"
      />
      {/* text-center beats the global h2 { text-align: left } in styles/globals.css */}
      <H2 className="mb-3 text-center">The new FFH app is here</H2>
      <BodyRegular className="mb-6 text-neutral-600">
        For the best FFH experience, download our new app - winning just got
        even easier.
      </BodyRegular>
      <AppUpsellCta
        storeUrl={storeUrl}
        ctaLabel={ctaLabel}
        onClick={onCtaClick}
        dataCy="app-upsell-modal-cta"
      />
    </div>
  </FFHModal>
);

export default AppUpsellModal;
